import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import { ListingHero } from './components/ListingHero';
import { ListingGrid } from './components/ListingGrid';
import { eventService } from '../../utils/api/event.service';
import { CATEGORIES } from '../../constants/categories';

export const Listing = () => {
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const category = CATEGORIES[id] || { bgClass: 'hero-bg-listing-arts' };

  useEffect(() => {
    // Re-initialize Webflow IX2 after component mount
    const initWebflow = () => {
      if (window.Webflow) {
        window.Webflow.destroy();
        window.Webflow.ready();
        window.Webflow.require('ix2').init();
      }
    };

    const fetchEvents = async () => {
      setLoading(true);
      try {
        const data = await eventService.getUpcomingEvents(id);
        setEvents(data.result || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError(err.message);
      } finally {
        setLoading(false);
        // Small delay to ensure React has finished rendering before re-init
        setTimeout(initWebflow, 100);
      }
    };

    fetchEvents();
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div className={`${category.bgClass || 'hero-bg-listing-arts'} bg`}>
      <Navbar dark={true} />
      <ListingHero categoryId={id} />
      {loading ? (
        <div className="listing-wrapper" style={{textAlign: 'center', padding: '100px', color: 'white'}}>
          <h2>Loading events...</h2>
        </div>
      ) : error ? (
        <div className="listing-wrapper" style={{textAlign: 'center', padding: '100px', color: 'white'}}>
          <h2>{error}</h2>
        </div>
      ) : (
        <ListingGrid events={events} />
      )}
      <Footer />
    </div>
  );
};
